import { Outlet, useOutletContext } from 'react-router-dom'

import NotFound from 'modules/core/components/NotFound'

import { AutomationDetails } from 'modules/automations/components/AutomationDetails'
import type { ShowRouteContextParams } from 'modules/automations/lib/ShowRouteContextParams'
import { InsertAutomationProvider } from 'modules/automations/lib/automationContext'

const DetailsPage = () => {
  const { automation, automationCreator, trigger, back } =
    useOutletContext<ShowRouteContextParams>()
  if (trigger === undefined) return <></>

  if (!automation) {
    return <NotFound />
  }

  return (
    <InsertAutomationProvider>
      <AutomationDetails
        automation={automation}
        automationCreator={automationCreator}
        trigger={trigger}
        back={back}
      >
        {trigger && <Outlet context={trigger} />}
      </AutomationDetails>
    </InsertAutomationProvider>
  )
}

export default DetailsPage
